"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;

var default_1 = require("./default");

exports.config = Object.assign(Object.assign({}, default_1.config), {
  elementTags: {
    blockquote: function blockquote() {
      return {
        type: 'block-quote'
      };
    },
    h1: function h1() {
      return {
        type: 'heading-one'
      };
    },
    h2: function h2() {
      return {
        type: 'heading-two'
      };
    },
    li: function li() {
      return {
        type: 'list-item'
      };
    },
    ol: function ol() {
      return {
        type: 'numbered-list'
      };
    },
    ul: function ul() {
      return {
        type: 'bulleted-list'
      };
    },
    p: function p() {
      return {
        type: 'paragraph'
      };
    }
  }
});